'use strict';

const { h } = require('phy');

const CouponsList = require('../../coupons/views/coupons-list-hoc');
const SecondaryTitle = require('../../coupons/views/secondary-title');

function MainContent({ couponsForList, routes }) {
  if (!Array.isArray(couponsForList) || !couponsForList.length) {
    return null;
  }

  return [
    h(SecondaryTitle, {
      resourceKey: 'modules.top_offers.PageSubHeadingFormat',
      params: {
        0: couponsForList[0].calloutValue,
        1: couponsForList[0].merchant.merchantName,
      },
    }),
    h(
      '',
      {
        'data-bhw': 'TopOffersCouponsList',
      },
      h(CouponsList, { routes, coupons: couponsForList })
    ),
  ];
}

module.exports = MainContent;
